import { defineMessages } from 'react-intl';

export default defineMessages({
  noRelevantProjectsHeader: {
    id: 'frontbucket.jiraPage.noRelevantProjectsHeader',
    description:
      'Header for no relevant projects empty state of the issues list',
    defaultMessage: `You haven't linked issues within this repository`,
  },
  noRelevantProjectsDescription: {
    id: 'frontbucket.jiraPage.noRelevantProjectsDescription',
    description:
      'Descriptive text for no relevant projects empty state of the issues list',
    defaultMessage:
      'Link a commit to an issue to associate its project with this repo.',
  },
  noRelevantProjectsLearnMoreLink: {
    id: 'frontbucket.jiraPage.noRelevantProjectsLearnMoreLink',
    description:
      'A link to more information about using relevant jira projects',
    defaultMessage: 'Learn more',
  },
  noAccessToRelevantProjectsHeader: {
    id: 'frontbucket.jiraPage.noAccessToRelevantProjectsHeader',
    description:
      'Header for no accessible relevant projects empty state of the issues list',
    defaultMessage: `It looks like you don't have access to the projects on this Jira site.`,
  },
  noAccessToRelevantSitesHeader: {
    id: 'frontbucket.jiraPage.noAccessToRelevantSitesHeader',
    description:
      'Header for no accessible relevant sites empty state of the issues list',
    defaultMessage: `It looks like you don't have permission to access your Jira site.`,
  },
  noAccessToRelevantProjectOrSiteDescription: {
    id: 'frontbucket.jiraPage.noAccessToRelevantProjectOrSiteDescription',
    description:
      'Descriptive text for no accessible relevant projects or sites empty state of the issues list',
    defaultMessage:
      'Contact your administrator to get access and see your sites and projects on this page.',
  },
  noMatchingIssuesHeader: {
    id: 'frontbucket.jiraPage.noMatchingIssuesHeader',
    description:
      'Header for no issues matching configured filters empty state of the issues list',
    defaultMessage: 'No issues were found to match your search or filter',
  },
  noMatchingIssuesDescription: {
    id: 'frontbucket.jiraPage.noMatchingIssuesDescription',
    description:
      'Descriptive text for no issues matching configured filters empty state of the issues list',
    defaultMessage:
      'Try modifying your search criteria or use Jira advanced search.',
  },
  openJiraLink: {
    id: 'frontbucket.jiraPage.openJiraLink',
    description: 'A link to Jira',
    defaultMessage: 'Open Jira',
  },
  noIssuesHeader: {
    id: 'frontbucket.jiraPage.noIssuesHeader',
    description:
      'Header for no issues in relevant projects empty state of the issues list',
    defaultMessage: 'This project has no issues',
  },
  noIssuesDescription: {
    id: 'frontbucket.jiraPage.noIssuesDescription',
    description:
      'Descriptive text for no issues in relevant projects empty state of the issues list',
    defaultMessage: 'Create an issue in Jira to see it here.',
  },
});
